const moduleViewMixin = {
  methods: {
    getTableList(tables) {
      return tables ? tables.filter((table) => {
        return ![
          this.permissionTypes.none,
          this.permissionTypes.deny,
        ].includes(table.currentUserPermissionLevel);
      }) : [];
    },
    canCreate(folder) {
      return [
        this.permissionTypes.admin,
        this.permissionTypes.edit,
      ].includes(folder.currentUserPermissionLevel);
    },
    canEdit(folder) {
      return [
        this.permissionTypes.admin,
        this.permissionTypes.edit,
      ].includes(folder.currentUserPermissionLevel);
    },
    canDelete(folder) {
      return [this.permissionTypes.admin].includes(folder.currentUserPermissionLevel);
    },
    canManagePermissions(folder) {
      return folder.currentUserPermissionLevel === this.permissionTypes.admin;
    },
    canCreateFolder(permissionLevel) {
      return [
        this.permissionTypes.admin,
        this.permissionTypes.edit,
      ].includes(permissionLevel);
    },
  },
};

export default moduleViewMixin;
